
import Vue from "vue";

export default Vue.extend({
  props: {
    title: {
      type: String,
      default: null,
    },
  },

  computed: {
    items(): Array<{ text: string, to: string }> {
      const fullPath = this.$route.fullPath;
      const params = fullPath.startsWith("/")
        ? fullPath.substring(1).split("/")
        : fullPath.split("/");
      const crumbs = [
        {
          text: "Home",
          to: "/",
        }];

      let path = "";

      const searchRegExp = /-/g;

      params.forEach((param) => {
        path = `${path}/${param}`;
        const match = this.$router.match(path);

        if (match.name != null) {
          const translationKey = "pages." + match.name.replace(searchRegExp, ".") + ".title";
          const translatedName = this.$t(translationKey);
          const title = translatedName !== translationKey
            ? translatedName
            : param.replace(/-/g, " ")
              .split(" ")
              .map(w => w.length > 0 ? w[0].toUpperCase() + w.substr(1) : "")
              .join(" ");
          if (title !== "") {
            crumbs.push({
              text: title.toString(),
              to: path,
            });
          }
        }
      });

      return crumbs;
    },
  },
});
